var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E2FFE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_17321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3675 22.2998C41.7023 22.6347 41.8903 23.0888 41.8903 23.5623C41.8903 24.0358 41.7023 24.4899 41.3675 24.8248L27.983 38.2093C27.8061 38.3862 27.5961 38.5266 27.365 38.6223C27.1338 38.7181 26.8861 38.7674 26.6359 38.7674C26.3858 38.7674 26.138 38.7181 25.9069 38.6223C25.6758 38.5266 25.4658 38.3862 25.2889 38.2093L18.6389 31.5605C18.4684 31.3958 18.3323 31.1987 18.2387 30.9809C18.1451 30.763 18.0959 30.5287 18.0938 30.2916C18.0918 30.0545 18.1369 29.8193 18.2267 29.5999C18.3165 29.3804 18.4491 29.181 18.6168 29.0134C18.7844 28.8457 18.9838 28.7131 19.2033 28.6233C19.4227 28.5335 19.6579 28.4884 19.895 28.4904C20.1321 28.4925 20.3664 28.5417 20.5843 28.6353C20.8021 28.7289 20.9992 28.865 21.1639 29.0355L26.6353 34.5069L38.8413 22.2998C39.0071 22.1339 39.204 22.0022 39.4208 21.9124C39.6375 21.8226 39.8698 21.7764 40.1044 21.7764C40.339 21.7764 40.5713 21.8226 40.788 21.9124C41.0047 22.0022 41.2016 22.1339 41.3675 22.2998Z",
    fill: "#2EBB49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_17321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5714,
    height: 28.5714,
    fill: "white",
    transform: "translate(15.7148 16.2144)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkgreen);
export default __webpack_public_path__ + "static/media/checkmarkgreen.083336d45b9b79216bb907c9cf9b65d3.svg";
export { ForwardRef as ReactComponent };